import { useCollapseSidebarIfExpanded } from './useSidebarMode';

export function useProcessNavTransition() {
  const collapseSidebarIfExpanded = useCollapseSidebarIfExpanded();

  return () => {
    collapseSidebarIfExpanded();
  };
}
